
import Event = createjs.Event;

export class Poker2OnTableEvent extends Event {

    public static START_GAME: string = "startgame";
    public static FINISH_GAME: string = "finishgame";
    public static SHOWDOWN: string = "showdown";
    public static SHOW_RABBIT_CAM: string = "showRabbitCam";
    public static HIDE_RABBIT_CAM: string = "hideRabbitCam";
    public static RESET_GAME: string = "resetgame";
    public static MYPLAYER_TURN: string = "myplayerTurn";
    public static PLAYER_ACTION: string = "playerAction";
    public static NEXT_ROUND: string = "nextRound";
    public static NEXT_PLAYER: string = "nextplayer";
    public static GET_GIFT: string = "getGift";
    public static PLAYERCARDS: string = "playercards";
    public static COMMUNITYCARDS: string = "communitycards";
    public static HANDCATEGORY: string = "handcategory";
    public static PLAYER_JOIN: string = "playerJoin";
    public static PLAYER_LEAVE: string = "playerLeave";
    public static CHANGE_DEALER: string = "changeDealer";

    public static PLAYER_LEVEL_UP: string = "playerLevelUp";

    public static TABLE_SIT_DOWN: string = "sitDown";
    public static TABLE_STAND_UP: string = "standUp";
    public static CHANGE_CURRENT_TABLE_DATA: string = "changeCurrentTableData";
    public static EMPTY_TABLE: string = "onEmptyTable";

    public static UNLOCK_ACTION_PANEL: string = "unlockActionPanel";
    public static UNLOCK_JOINBUTTONS: string = "unlockJoinButtons";

    public static BOOK_SEAT: string = "bookSeat";
    public static BOOKED_SEAT: string = "bookedSeat";
    public static BOOK_RELEASED: string = "bookReleased";

    public static SHOWDOWN_ANIMATION_COMPLETE: string = "showdownAnimationComplete";

    public static PLAY_RABBIT_CAM: string = "playRabbitCam";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
